export function SEARCH_VALIDATOR(value: string): boolean {
  if (value && value.length < 3) {
    throw new Error('Must be 3 characters or more');
  }

  return true;
}
